// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-tabs {\n  max-width: 100%; }\n  .ant-tabs .ant-tabs-nav {\n    background: white;\n    padding: 0 32px;\n    margin-bottom: 0; }\n    .ant-tabs .ant-tabs-nav:before {\n      display: none; }\n  .ant-tabs .ant-tabs-content-holder {\n    padding: 32px; }\n\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  font-weight: 600; }\n\n.Tabs_spaceTop__2SBQS .ant-tabs-nav {\n  padding-top: 22px; }\n", ""]);
// Exports
exports.locals = {
	"spaceTop": "Tabs_spaceTop__2SBQS"
};
module.exports = exports;
